export default __webpack_public_path__ + "static/media/10.d08d3209.jpg";